import {  Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";
import { NavigateFunction } from "react-router";



type Props = {
  onActionEditar: (Id: number | null, openState: boolean ) => void,
  onActionDeletar: (Id: number | null, openState: boolean) => void,
  navigate: NavigateFunction;
};

export const GenerateControleEstoqueColumns = ({
  onActionEditar,
  onActionDeletar,
  navigate
}: Props): GridColDef[] => {

  return [
    {
      field: "NomeCentroCusto",
      filterable: false,
      headerName: "Centro Custo",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "Descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "Itens",
      filterable: false,
      headerName: "Itens",
      flex: 3,
      maxWidth: 90,
      sortable: false,
      valueGetter: (_, row) => row['IdControleEstoque'] as number,
      renderCell: (params) => { 
          const id = params.value; 
          return (
              <Button
                onMouseDown={() => navigate(`/ControleEstoque_cadastro/${id}`)}
                sx={{
                    fontSize: 11,
                    paddingX: '.4rem',
                    paddingY: 0,
                    background: '#e6e6e6',
                    borderLeft: '.2rem solid #45b6af',
                    color: 'black',
                    fontWeight: 'normal',
                }}>
                Itens
              </Button>
          );
      },
    },
    {
    field: 'IdControleEstoque',
    sortable: false,
    filterable: false,
    headerName: 'Ações',
    minWidth: 150,
    renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-1">
            
            <IconButton onClick={() => onActionEditar(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={22} className="dark:text-white text-primary-green" />
            </IconButton> 
            <IconButton onClick={() => onActionDeletar(params.value, true)} >
              <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
            </IconButton>

          </div>
        );
      }
    },
  ];
}